import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// component
import Loader from "Components/UI/Loader";
import PrivateRoutes from "AppPrivateRoutes";
import { routes } from "Library/Constants";

// Pages
const Token = lazy(() => import("./Pages/Token"));
const Account = lazy(() => import("./Pages/Account"));
const Projects = lazy(() => import("./Pages/Projects"));
const Project = lazy(() => import("./Pages/Project"));
const Roles = lazy(() => import("./Pages/Roles"));
const Organizations = lazy(() => import("./Pages/Organizations"));
const Organization = lazy(() => import("./Pages/Organization"));
const Users = lazy(() => import("./Pages/Users"));
const User = lazy(() => import("./Pages/User"));
const Platforms = lazy(() => import("./Pages/Platforms"));
const Webhooks = lazy(() => import("./Pages/Webhooks"));
const Webhook = lazy(() => import("./Pages/Webhook"));
const Equipment = lazy(() => import("./Pages/Equipments"));
const Vehicle = lazy(() => import("./Pages/Vehicles"));
const SystemBanners = lazy(() => import("./Pages/SystemBanners"));
const AnthropicKey = lazy(() => import("./Pages/GlobalVariables/AnthropicKey"));
const AnthropicModel = lazy(() => import("./Pages/GlobalVariables/AnthropicModel"));
const InventoryLedgerAlerts = lazy(() => import("./Pages/GlobalVariables/InventoryLedgerAlerts"));

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Token />} />
          <Route path={routes.root.dashboard} element={<PrivateRoutes />}>
            <Route index element={<Projects />} />
            <Route path={routes.dashboard.account} element={<Account />} />
            <Route path={routes.dashboard.projects} element={<Projects />} />
            <Route path={routes.dashboard.project} element={<Project />} />
            <Route path={routes.dashboard.roles} element={<Roles />} />
            <Route
              path={routes.dashboard.organizations}
              element={<Organizations />}
            />
            <Route
              path={routes.dashboard.organization}
              element={<Organization />}
            />
            <Route path={routes.dashboard.users} element={<Users />} />
            <Route path={routes.dashboard.user} element={<User />} />
            <Route path={routes.dashboard.platforms} element={<Platforms />} />
            <Route path={routes.dashboard.webhooks} element={<Webhooks />} />
            <Route path={routes.dashboard.webhook} element={<Webhook />} />
            <Route
              path={routes.dashboard.equipmentMaster}
              element={<Equipment />}
            />
            <Route
              path={routes.dashboard.vehicleMaster}
              element={<Vehicle />}
            />
            <Route path={routes.dashboard.systemBanners} element={<SystemBanners />} />
            <Route path={routes.dashboard.anthropicKey} element={<AnthropicKey />} />
            <Route path={routes.dashboard.anthropicModel} element={<AnthropicModel />} />
            <Route path={routes.dashboard.inventoryLedgerAlerts} element={<InventoryLedgerAlerts />} />
          </Route>
          <Route path="*" element={<Navigate to={"/"} />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
